import { render, staticRenderFns } from "./google-search-in-drive-settings.vue?vue&type=template&id=c5393264&scoped=true"
import script from "./google-search-in-drive-settings.vue?vue&type=script&lang=js"
export * from "./google-search-in-drive-settings.vue?vue&type=script&lang=js"
import style0 from "./google-search-in-drive-settings.vue?vue&type=style&index=0&id=c5393264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5393264",
  null
  
)

export default component.exports